// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { of, Observable } from 'rxjs';

// --- HS Code
import { SurveySummaryModel } from '../../../models/survey/survey-summary-model';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class DashboardBaseService {

  constructor() { }

  getSurveySummary(identifier: string): Observable<SurveySummaryModel> {
    return of({} as SurveySummaryModel);
  }
}
